const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://avocalendar.com:3001/api';

export default {
    API_BASE_URL
}; 